let _ = require('lodash');

const sum = (array) =>
  _(array)
    .compact()
    .reduce((sum, num) => sum + num, 0);

export default sum;
